@import "../../common-input";

:host {
  --goat-textarea-height: 2.5rem;
}

.textarea {
  height: 100%;
  position: relative;
  align-items: flex-start;

  .input-native {
    height: 100%;
    min-height: var(--goat-textarea-height);
    resize: vertical;
    padding:v(--spacing-05);
  }
}

.actions-container {
  position: absolute;
  right: 1rem;
  top: 0.5rem;

  goat-button {
    --goat-button-height: 2rem;
  }
}

:host([size=md]) .input-container {
  height: 100%;
  min-height: var(--goat-textarea-height);
}


